import styled from 'styled-components';
import colors from '../../../../constants/colors';
import { hideOnMobile } from '../../../../constants/globalStyles';

import Back from '../../../Back';

export const Wrapper = styled.div`
  margin: 110px 0;

  @media screen and (max-width: 992px) {
    margin: 0 auto 60px;
    width: 100%;
  }
`;

export const Content = styled.div`
  margin: 0 auto;
  width: 990px;
  min-height: 650px;
  display: flex;
  background-color: ${colors.main.white};
  border-radius: 2px;
  position: relative;

  @media screen and (max-width: 992px) {
    flex-direction: column;
    width: 100%;
  }
`;

export const Gradient = styled.div`
  background: rgb(240, 242, 245);
  width: 30px;
  background: linear-gradient(to right, #f0f2f5, #ffffff);
  opacity: 0.8;
  ${hideOnMobile}
`;

export const StyledBack = styled(Back)`
  display: none;
  position: absolute;
  top: 15px;
  left: 20px;
  z-index: 100;

  @media screen and (max-width: 992px) {
    display: block;
  }
`;
